module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lessonsblock"
  }, [(_vm.isOpenBlock) ? _c('p', {
    staticClass: "lessonsblock__link",
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Закрыть")]) : [(!_vm.isLinks) ? _c('p', {
    staticClass: "lessonsblock__link lessonsblock__link_grey"
  }, [_vm._v("Дополнительных материалов нет")]) : _c('p', {
    staticClass: "lessonsblock__link",
    on: {
      "click": function($event) {
        return _vm.$emit("lookItems")
      }
    }
  }, [_vm._v("Посмотреть материалы урока")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65a81cea","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/components/block/components/legend/components/lessonsblock/LessonsBlock.vue
// module id = a9e395909ee477f7fcf6
// module chunks = 89